import { LogicalAdd, LogicalAnd, LogicalBigger, LogicalBiggerOrEquals, LogicalEquals, LogicalFalse, LogicalMultiply, LogicalNot, LogicalNumber, LogicalOr, LogicalSmaller, LogicalSmallerOrEquals, LogicalTrue, LogicalVariable } from "./LogicalExpression";

// ---- PARSER -------------------------- 
export class LogicalExpressionParser {
    constructor() {
    }
    parse(str) {
        return this.parseLogicalExpression(str);
    }
    parseLogicalExpression(str) {
        return LogicalExpressionParser.parseLogicalExpression(str);
    }
    static parseLogicalExpression(str) {
        var decoder = new LogicalExpressionDecoder(str);
        return decoder.value;
    }
    static serializeLogicalExpression(le) {
        return le.toString();
    }
}



// ---- DECODER --------------------------
export class LogicalExpressionDecoder {
    constructor(s) {
        this.tokenizer = new LogicalExpressionTokenizer(s);
        this.token = null;
        this.value = null;

        this.nextToken();

        this.value = this.parseExpression();

        if (this.nextToken() != null) {
            this.tokenizer.parseError("Unexpected characters left in input stream");
        }
    }

    parseExpression() {
        var operatorStack = [];
        var outputStack = [];
        var lastOp = null;

        while (true) {
            if (this.token == null) {
                break;
            }

            switch (this.token.type) {
                case LogicalExpressionTokenType.MULTIPLY:
                case LogicalExpressionTokenType.ADD:
                case LogicalExpressionTokenType.BIGGER:
                case LogicalExpressionTokenType.BIGGEROREQUALS:
                case LogicalExpressionTokenType.SMALLER:
                case LogicalExpressionTokenType.SMALLEROREQUALS:
                case LogicalExpressionTokenType.EQUALS:
                case LogicalExpressionTokenType.AND:
                case LogicalExpressionTokenType.OR:
                case LogicalExpressionTokenType.NOT:
                    if (operatorStack.length > 0) {
                        lastOp = operatorStack[operatorStack.length - 1];
                    } else {
                        lastOp = null;
                    }

                    if (lastOp == null || lastOp.type == LogicalExpressionTokenType.LEFT_PARANTHESES) {
                        operatorStack.push(this.token);
                    } else if (this.priority(this.token.type) < this.priority(lastOp.type)) {
                        operatorStack.push(this.token);
                    } else {
                        while (this.priority(this.token.type) >= this.priority(lastOp.type)) {
                            operatorStack.pop();
                            outputStack.push(lastOp);

                            if (operatorStack.length > 0) {
                                lastOp = operatorStack[operatorStack.length - 1];
                            } else {
                                lastOp = null;
                            }
                            if (lastOp == null || lastOp.type == LogicalExpressionTokenType.LEFT_PARANTHESES) {
                                break;
                            }
                        }
                        operatorStack.push(this.token);
                    }
                    break;
                case LogicalExpressionTokenType.NUMBER:
                case LogicalExpressionTokenType.TRUE:
                case LogicalExpressionTokenType.FALSE:
                case LogicalExpressionTokenType.VARIABLE:
                    outputStack.push(this.token);
                    break;
                case LogicalExpressionTokenType.LEFT_PARANTHESES:
                    operatorStack.push(this.token);
                    break;
                case LogicalExpressionTokenType.RIGHT_PARANTHESES:
                    while (true) {
                        lastOp = operatorStack.pop();
                        if (lastOp == null) {
                            this.tokenizer.parseError("Mismatched parentheses");
                        } else if (lastOp.type == LogicalExpressionTokenType.LEFT_PARANTHESES) {
                            break;
                        } else {
                            outputStack.push(lastOp);
                        }
                    }
                    break;
                default:
                    this.tokenizer.parseError("Unknown token type: " + this.token.type);
                    break;
            }

            //Get the next token
            this.nextToken();
        }

        //Operations after all tokens have been processed	
        while (operatorStack.length > 0) {
            lastOp = operatorStack.pop();
            if (lastOp.type == LogicalExpressionTokenType.LEFT_PARANTHESES || lastOp.type == LogicalExpressionTokenType.RIGHT_PARANTHESES) {
                this.tokenizer.parseError("Mismatched parentheses");
            }
            outputStack.push(lastOp);
        }

        // END of Shunting yard algorithm 

        //Phase 2: convert the postfix ordered tokens to a logical structure	
        var result = this.parseExpressionFromPostFixStack(outputStack);

        //Check if the output stack is empty
        if (outputStack.length > 0) {
            this.tokenizer.parseError("Incorrect syntax, token after parsing expression");
        }
        return result;
    };

    parseExpressionFromPostFixStack(stack) {
        var token = stack.pop();
        var result = null;
        var rightBooleanOperand = null;
        var leftBooleanOperand = null;
        var rightNumberOperand = null;
        var leftNumberOperand = null;

        if (!token) {
            this.tokenizer.parseError("Unexpected end of expression");
        }

        switch (token.type) {
            case LogicalExpressionTokenType.MULTIPLY:
                rightNumberOperand = this.parseLogicalNumber(stack);
                leftNumberOperand = this.parseLogicalNumber(stack);
                result = new LogicalMultiply(leftNumberOperand, rightNumberOperand);
                break;
            case LogicalExpressionTokenType.ADD:
                rightNumberOperand = this.parseLogicalNumber(stack);
                leftNumberOperand = this.parseLogicalNumber(stack);
                result = new LogicalAdd(leftNumberOperand, rightNumberOperand);
                break;
            case LogicalExpressionTokenType.BIGGER:
                rightNumberOperand = this.parseLogicalNumber(stack);
                leftNumberOperand = this.parseLogicalNumber(stack);
                result = new LogicalBigger(leftNumberOperand, rightNumberOperand);
                break;
            case LogicalExpressionTokenType.BIGGEROREQUALS:
                rightNumberOperand = this.parseLogicalNumber(stack);
                leftNumberOperand = this.parseLogicalNumber(stack);
                result = new LogicalBiggerOrEquals(leftNumberOperand, rightNumberOperand);
                break;
            case LogicalExpressionTokenType.EQUALS:
                rightNumberOperand = this.parseLogicalNumber(stack);
                leftNumberOperand = this.parseLogicalNumber(stack);
                result = new LogicalEquals(leftNumberOperand, rightNumberOperand);
                break;
            case LogicalExpressionTokenType.SMALLER:
                rightNumberOperand = this.parseLogicalNumber(stack);
                leftNumberOperand = this.parseLogicalNumber(stack);
                result = new LogicalSmaller(leftNumberOperand, rightNumberOperand);
                break;
            case LogicalExpressionTokenType.SMALLEROREQUALS:
                rightNumberOperand = this.parseLogicalNumber(stack);
                leftNumberOperand = this.parseLogicalNumber(stack);
                result = new LogicalSmallerOrEquals(leftNumberOperand, rightNumberOperand);
                break;
            case LogicalExpressionTokenType.AND:
                rightBooleanOperand = this.parseLogicalBoolean(stack);
                leftBooleanOperand = this.parseLogicalBoolean(stack);
                result = new LogicalAnd(leftBooleanOperand, rightBooleanOperand);
                break;
            case LogicalExpressionTokenType.OR:
                rightBooleanOperand = this.parseLogicalBoolean(stack);
                leftBooleanOperand = this.parseLogicalBoolean(stack);
                result = new LogicalOr(leftBooleanOperand, rightBooleanOperand);
                break;
            case LogicalExpressionTokenType.NOT:
                leftBooleanOperand = this.parseLogicalBoolean(stack);
                result = new LogicalNot(leftBooleanOperand);
                break;
            case LogicalExpressionTokenType.TRUE:
                result = new LogicalTrue();
                break;
            case LogicalExpressionTokenType.FALSE:
                result = new LogicalFalse();
                break;
            case LogicalExpressionTokenType.VARIABLE:
                result = new LogicalVariable(token.value);
                break;
            case LogicalExpressionTokenType.NUMBER:
                result = new LogicalNumber(token.value);
                break;
            default:
                this.tokenizer.parseError("Error on converting postfix stack to expression, unexpected token tpe");
                break;
        }
        return result;
    };

    parseLogicalBoolean(stack) {
        var expression = this.parseExpressionFromPostFixStack(stack);

        return expression;
    };

    parseLogicalNumber(stack) {
        var expression = this.parseExpressionFromPostFixStack(stack);

        return expression;
    };

    nextToken() {
        this.token = this.tokenizer.getNextToken();

        return this.token;
    };

    priority(tokenType) {
        //Java operator priority: http://www.uni-bonn.de/~manfear/javaoperators.php
        switch (tokenType) {
            case LogicalExpressionTokenType.NOT:
                return 2;
                break;
            case LogicalExpressionTokenType.AND:
                return 11;
                break;
            case LogicalExpressionTokenType.OR:
                return 12;
                break;
            case LogicalExpressionTokenType.ADD:
                return 4;
                break;
            case LogicalExpressionTokenType.MULTIPLY:
                return 3;
                break;
            case LogicalExpressionTokenType.BIGGER:
            case LogicalExpressionTokenType.BIGGEROREQUALS:
            case LogicalExpressionTokenType.SMALLER:
            case LogicalExpressionTokenType.SMALLEROREQUALS:
                return 6;
                break;
            case LogicalExpressionTokenType.EQUALS:
                return 7;
                break;
            default:
                return Number.MAX_VALUE;
                break;
        }
    };


    static parseExpression(input) {
        var parser = new LogicalExpressionDecoder(input);
        return parser.getValue();
    }
}




// ---- TOKENIZER --------------------------
export class LogicalExpressionTokenizer {
    constructor(s) {
        this.lsString = s;
        this.loc = 0;
        this.ch = null;
        this.nextChar();
    }

    getNextToken() {
        var token = new LogicalExpressionToken();

        this.skipWhite();

        switch (this.ch) {
            case '(':
                token.type = LogicalExpressionTokenType.LEFT_PARANTHESES;
                token.value = '(';
                this.nextChar();
                break;
            case ')':
                token.type = LogicalExpressionTokenType.RIGHT_PARANTHESES;
                token.value = ')';
                this.nextChar();
                break;
            case ',':
                token.type = LogicalExpressionTokenType.COMMA;
                token.value = ',';
                this.nextChar();
                break;
            case '&':
                token.type = LogicalExpressionTokenType.AND;
                token.value = '&';
                this.nextChar();
                break;
            case '!':
                token.type = LogicalExpressionTokenType.NOT;
                token.value = '!';
                this.nextChar();
                break;
            case '|':
                token.type = LogicalExpressionTokenType.OR;
                token.value = '|';
                this.nextChar();
                break;
            case '>':
                this.nextChar();
                if (this.ch == '=') {
                    //Skip an extra char
                    this.nextChar();
                    token.type = LogicalExpressionTokenType.BIGGEROREQUALS;
                    token.value = ">=";
                } else {
                    token.type = LogicalExpressionTokenType.BIGGER;
                    token.value = '>';
                }

                break;
            case '<':
                this.nextChar();
                if (this.ch == '=') {
                    this.nextChar();
                    token.type = LogicalExpressionTokenType.SMALLEROREQUALS;
                    token.value = "<=";
                } else {
                    token.type = LogicalExpressionTokenType.SMALLER;
                    token.value = '<';
                }
                break;
            case '=':
                this.nextChar();
                if (this.ch == '=') {
                    this.nextChar();
                    token.type = LogicalExpressionTokenType.EQUALS;
                    token.value = '==';
                } else {
                    this.parseError("Unexpected '" + this.ch + "' after =");
                }
                break;
            case '+':
                token.type = LogicalExpressionTokenType.ADD;
                token.value = '+';
                this.nextChar();
                break;
            case '*':
                token.type = LogicalExpressionTokenType.MULTIPLY;
                token.value = '*';
                this.nextChar();
                break;
            case 'T':
            case 't': // attempt to read true
                var possibleTrue = this.ch + this.lsString.charAt(this.loc) + this.lsString.charAt(this.loc + 1) + this.lsString.charAt(this.loc + 2);
                if (possibleTrue.toLowerCase() == "true") {
                    //Skip the characters
                    this.nextChar();
                    this.nextChar();
                    this.nextChar();

                    token.type = LogicalExpressionTokenType.TRUE;
                    token.value = true;
                    this.nextChar();
                } else {
                    token = this.readVariableOrFunction();
                }
                break;
            case 'F':
            case 'f': // attempt to read false
                var possibleFalse = this.ch + this.lsString.charAt(this.loc) + this.lsString.charAt(this.loc + 1) + this.lsString.charAt(this.loc + 2) + this.lsString.charAt(this.loc + 3);
                if (possibleFalse.toLowerCase() == "false") {
                    //Skip the characters
                    this.nextChar();
                    this.nextChar();
                    this.nextChar();
                    this.nextChar();

                    token.type = LogicalExpressionTokenType.FALSE;
                    token.value = false;
                    this.nextChar();
                } else {
                    token = this.readVariableOrFunction();
                }
                break;
            case '':
                //End of input
                return null;
                break;
            default:
                if (this.isVariableCharacter(this.ch, true)) {
                    //Try to read a variable or function
                    token = this.readVariableOrFunction();
                } else if (this.isDigit(this.ch) || this.ch == '-') {
                    // see if we can read a number				
                    token = this.readNumber();
                } else {
                    // not sure what was in the input string - it's not
                    // anything we expected
                    this.parseError("Unexpected " + this.ch + " encountered");
                }
                break;
        }
        return token;
    };

    skipWhite() {
        while (this.isWhiteSpace(this.ch)) {
            this.nextChar();
        }
    };

    isWhiteSpace(ch) {
        if (ch == null)
            return false;
        if (ch == ' ' || ch == '\t' || ch == '\n' || ch == '\r') {
            return true;
        }

        return false;
    };

    isDigit(ch) {
        if (ch == null)
            return false;

        return (ch >= '0' && ch <= '9');
    };

    readNumber() {
        var input = "";

        // check for a negative number
        if (this.ch == '-') {
            input += '-';
            this.nextChar();
        }

        // the number must start with a digit
        if (!this.isDigit(this.ch)) {
            this.parseError("Expecting a digit");
        }

        // 0 can only be the first digit if it
        // is followed by a decimal point
        if (this.ch == '0') {
            input += this.ch;
            this.nextChar();

            // make sure no other digits come after 0
            if (this.isDigit(this.ch)) {
                this.parseError("A digit cannot immediately follow 0");
            }
            // unless we have 0x which starts a hex number, but this
            // doesn't match JSON spec so check for not strict mode.
            else if (this.ch == 'x') {
                // include the x in the input
                input += this.ch;
                nextChar();

                // need at least one hex digit after 0x to
                // be valid
                if (this.isHexDigit(this.ch)) {
                    input += this.ch;
                    this.nextChar();
                }
                else {
                    this.parseError("Number in hex format require at least one hex digit after \"0x\"");
                }

                // consume all of the hex values
                while (this.isHexDigit(ch)) {
                    input += this.ch;
                    this.nextChar();
                }
            }
        }
        else {
            // read numbers while we can
            while (this.isDigit(this.ch)) {
                input += this.ch;
                this.nextChar();
            }
        }

        // check for a decimal value
        if (this.ch == '.') {
            input += '.';
            this.nextChar();

            // after the decimal there has to be a digit
            if (!this.isDigit(this.ch)) {
                this.parseError("Expecting a digit");
            }

            // read more numbers to get the decimal value
            while (this.isDigit(this.ch)) {
                input += this.ch;
                this.nextChar();
            }
        }

        // check for scientific notation
        if (this.ch == 'e' || this.ch == 'E') {
            input += "e"
            this.nextChar();
            // check for sign
            if (this.ch == '+' || this.ch == '-') {
                input += this.ch;
                this.nextChar();
            }

            // require at least one number for the exponent
            // in this case
            if (!this.isDigit(this.ch)) {
                this.parseError("Scientific notation number needs exponent value");
            }

            // read in the exponent
            while (this.isDigit(this.ch)) {
                input += this.ch;
                this.nextChar();
            }
        }

        // convert the string to a number value
        var num = input;

        if (!isNaN(num) && isFinite(num)) {
            // the token for the number that we've read
            var token = new LogicalExpressionToken(LogicalExpressionTokenType.NUMBER, num);
            return token;
        }
        else {
            this.parseError("Number " + num + " is not valid!");
        }

        return null;
    };

    readVariableOrFunction() {
        var input = "";
        input += this.ch;
        this.nextChar();
        while (this.isVariableCharacter(this.ch, false)) {
            input += this.ch;
            this.nextChar();
        }

        if (this.ch == "(") {
            return new LogicalExpressionToken(LogicalExpressionTokenType.FUNCTION, input);
        } else {
            return new LogicalExpressionToken(LogicalExpressionTokenType.VARIABLE, input);
        }
    };

    isHexDigit(ch) {
        return (this.isDigit(ch) || (ch >= 'A' && ch <= 'F') || (ch >= 'a' && ch <= 'f'));
    };

    isVariableCharacter(ch, first) {
        if (this.isDigit(ch) && first) {
            return false;
        } else {
            if (this.isDigit(ch) || (ch >= 'A' && ch <= 'Z') || (ch >= 'a' && ch <= 'z') || ch == "_" || ch == "#" || ch == "@" || ch == ".") {
                return true;
            }
            return false;
        }
    };

    parseError(message) {
        throw message + " " + this.loc + " " + this.lsString;
    };

    nextChar() {
        var nwCh = this.ch = this.lsString.charAt(this.loc++);
        return nwCh;
    };
}

// ---- TOKEN --------------------------
class LogicalExpressionToken {
    constructor(type, value) {
        this.type = type;
        this.value = value;
    }
}

export const LogicalExpressionTokenType = {};

LogicalExpressionTokenType.UNKNOWN = -1;
LogicalExpressionTokenType.LEFT_PARANTHESES = 0;
LogicalExpressionTokenType.RIGHT_PARANTHESES = 1;
LogicalExpressionTokenType.TRUE = 2;
LogicalExpressionTokenType.FALSE = 3;
LogicalExpressionTokenType.AND = 4;
LogicalExpressionTokenType.NOT = 5;
LogicalExpressionTokenType.OR = 6;
LogicalExpressionTokenType.NUMBER = 8;
LogicalExpressionTokenType.VARIABLE = 9;
LogicalExpressionTokenType.FUNCTION = 10;
LogicalExpressionTokenType.COMMA = 11;
LogicalExpressionTokenType.ADD = 12;
LogicalExpressionTokenType.MULTIPLY = 13;
LogicalExpressionTokenType.BIGGER = 14;
LogicalExpressionTokenType.SMALLER = 15;
LogicalExpressionTokenType.BIGGEROREQUALS = 16;
LogicalExpressionTokenType.SMALLEROREQUALS = 17;
LogicalExpressionTokenType.EQUALS = 18;